/* tslint:disabled */
/* eslint-disable */
/**
 * Guardrails
 * The service allows to get create guardrails, update, delete, add to folder, remove from folder them. Also it allows to list, create, update and delete folders.
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  AlertSeverityEnum,
  AlertSeverityEnumFromJSON,
  AlertSeverityEnumToJSON,
  Folder,
  FolderFromJSON,
  FolderToJSON,
  GuardrailTypeEnum,
  GuardrailTypeEnumFromJSON,
  GuardrailTypeEnumToJSON
} from './'

/**
 *
 * @export
 * @interface GuardrailSummary
 */
export interface GuardrailSummary {
  /**
   *
   * @type {string}
   * @memberof GuardrailSummary
   */
  id?: string
  /**
   *
   * @type {string}
   * @memberof GuardrailSummary
   */
  name?: string
  /**
   *
   * @type {GuardrailTypeEnum}
   * @memberof GuardrailSummary
   */
  type?: GuardrailTypeEnum
  /**
   *
   * @type {AlertSeverityEnum}
   * @memberof GuardrailSummary
   */
  alertSeverity?: AlertSeverityEnum
  /**
   *
   * @type {boolean}
   * @memberof GuardrailSummary
   */
  enabled?: boolean
  /**
   *
   * @type {boolean}
   * @memberof GuardrailSummary
   */
  builtIn?: boolean
  /**
   *
   * @type {string}
   * @memberof GuardrailSummary
   */
  query?: string
  /**
   *
   * @type {string}
   * @memberof GuardrailSummary
   */
  autoIntentId?: string
  /**
   *
   * @type {Array<Folder>}
   * @memberof GuardrailSummary
   */
  folders?: Array<Folder>
  /**
   *
   * @type {number}
   * @memberof GuardrailSummary
   */
  failedObjectsCount?: number
  /**
   *
   * @type {string}
   * @memberof GuardrailSummary
   */
  createdBy?: string
  /**
   *
   * @type {string}
   * @memberof GuardrailSummary
   */
  createdDateTime?: string
  /**
   *
   * @type {string}
   * @memberof GuardrailSummary
   */
  lastAlertDateTime?: string
  /**
   *
   * @type {string}
   * @memberof GuardrailSummary
   */
  lastUpdatedBy?: string
}

export function GuardrailSummaryFromJSON(json: any): GuardrailSummary {
  return {
    id: !exists(json, 'id') ? undefined : json['id'],
    name: !exists(json, 'name') ? undefined : json['name'],
    type: !exists(json, 'type')
      ? undefined
      : GuardrailTypeEnumFromJSON(json['type']),
    alertSeverity: !exists(json, 'alertSeverity')
      ? undefined
      : AlertSeverityEnumFromJSON(json['alertSeverity']),
    enabled: !exists(json, 'enabled') ? undefined : json['enabled'],
    builtIn: !exists(json, 'builtIn') ? undefined : json['builtIn'],
    query: !exists(json, 'query') ? undefined : json['query'],
    autoIntentId: !exists(json, 'autoIntentId')
      ? undefined
      : json['autoIntentId'],
    folders: !exists(json, 'folders')
      ? undefined
      : (json['folders'] as Array<any>).map(FolderFromJSON),
    failedObjectsCount: !exists(json, 'failedObjectsCount')
      ? undefined
      : json['failedObjectsCount'],
    createdBy: !exists(json, 'createdBy') ? undefined : json['createdBy'],
    createdDateTime: !exists(json, 'createdDateTime')
      ? undefined
      : json['createdDateTime'],
    lastAlertDateTime: !exists(json, 'lastAlertDateTime')
      ? undefined
      : json['lastAlertDateTime'],
    lastUpdatedBy: !exists(json, 'lastUpdatedBy')
      ? undefined
      : json['lastUpdatedBy']
  }
}

export function GuardrailSummaryToJSON(value?: GuardrailSummary): any {
  if (value === undefined) {
    return undefined
  }
  return {
    id: value.id,
    name: value.name,
    type: GuardrailTypeEnumToJSON(value.type),
    alertSeverity: AlertSeverityEnumToJSON(value.alertSeverity),
    enabled: value.enabled,
    builtIn: value.builtIn,
    query: value.query,
    autoIntentId: value.autoIntentId,
    folders:
      value.folders === undefined
        ? undefined
        : (value.folders as Array<any>).map(FolderToJSON),
    failedObjectsCount: value.failedObjectsCount,
    createdBy: value.createdBy,
    createdDateTime: value.createdDateTime,
    lastAlertDateTime: value.lastAlertDateTime,
    lastUpdatedBy: value.lastUpdatedBy
  }
}
